import { makeActionFactory } from './actionFactory';
import { CameraMessage, CellIndex, DeviceId, Timeline, UtcTime } from 'types';

export type ActionType =
    'TIMELINE_REQUEST'
    | 'TIMELINE_DATA_RECEIVED'
    | 'TIMELINE_SUCCESS'
    | 'TIMELINE_FAILURE'
    | 'TIMELINES_REDRAW'
    | 'TIMELINE_CLICK'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  TIMELINE_REQUEST action notifies the app that we're trying to load timeline for a specific camera and time range
//
export interface TimelineRequestAction {
    type: 'TIMELINE_REQUEST';
    payload: {
        deviceId: DeviceId;
        utcDate: Date;
    };
}
export const timelineRequest = actionFactory.payload<TimelineRequestAction, { deviceId: DeviceId; utcDate: Date }>('TIMELINE_REQUEST');


//
//  TIMELINE_DATA_RECEIVED action notifies the app that we received raw camera message data for a device.
//  The data gets processed in a worker thread and the final timline data is eventually sent in TIMELINE_SUCCESS.
//
export interface TimelineDataReceivedAction {
    type: 'TIMELINE_DATA_RECEIVED';
    payload: CameraMessage[];
    meta: {
        deviceId: DeviceId;
        utcDate: Date | null;
        append: boolean;
    };
}
export const timelineDataReceived = actionFactory.payloadMeta<TimelineDataReceivedAction, ReadonlyArray<CameraMessage>, TimelineDataReceivedAction['meta']>('TIMELINE_DATA_RECEIVED'); // tslint:disable-line


//
//  TIMELINE_SUCCESS action notifies the app that we successfully loaded timeline for a specific camera and time range
//
export interface TimelineSuccessAction {
    type: 'TIMELINE_SUCCESS';
    payload: Timeline;
    meta: {
        cellIndex: CellIndex;
        utcDate: Date;
    };
}
export const timelineSuccess = actionFactory.payloadMeta<TimelineSuccessAction, Timeline, { cellIndex: CellIndex; utcDate: Date }>('TIMELINE_SUCCESS');


//
//  TIMELINE_FAILURE action notifies the app that we failed to load timeline for a specific camera and time range
//
export interface TimelineFailureAction {
    type: 'TIMELINE_FAILURE';
    payload: Error;
    error: true;
    meta: {
        deviceId: DeviceId;
        utcDate: Date;
    };
}
export const timelineFailure = actionFactory.errorMeta<TimelineFailureAction, { deviceId: DeviceId; utcDate: Date }>('TIMELINE_FAILURE');


//
//  TIMELINES_REDRAW action notifies the app that some or all timelines need to be redrawn (e.g. after window size changed)
//
export interface TimelinesRedrawAction {
    type: 'TIMELINES_REDRAW';
}
export const timelinesRedraw = actionFactory.empty<TimelinesRedrawAction>('TIMELINES_REDRAW');


//
//  TIMELINE_CLICK action happens when a user clicks on a timeline
//
export interface TimelineClickAction {
    type: 'TIMELINE_CLICK';
    payload: {
        cellIndex: CellIndex;
        utcTime: UtcTime;
    };
}
export const timelineClick = actionFactory.payload<TimelineClickAction, TimelineClickAction['payload']>('TIMELINE_CLICK');



// WEBPACK FOOTER //
// ./src/actions/timelineActions.ts